<template>
  <div class="floating-window-container">
    <div class="flex fxdc aic">
      <img src="https://qishimai-1257428522.file.myqcloud.com/website/new/gotop_icon.png" style="height:70px;padding: 6px" @click="goTop" />
      <div class="flex fxdc aic customerservice-code-box">
        <img src="https://qishimai-1257428522.file.myqcloud.com/website/new/QR_code/customerservice_code.jpeg" style="width:120px" />
        <div class="fs13 gray-color" style="margin:6px 0 4px 0;">扫描客服二维码</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatingWindow',
  data () {
    return { }
  },
  methods: {
    goTop() {
      setTimeout(() => {
        document.getElementById('banner').scrollIntoView({block: "center", behavior: "smooth"});
      }, 10)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.floating-window-container {
  position: fixed;
  top: 35%;
  right: 40px;
  z-index: 4;
}
.customerservice-code-box{
  padding: 8px;
  background-color: #FFFFFF;
  box-shadow: 0px 3px 8px rgba(114, 114, 114, 0.16);
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/FloatingWindow.vue